export const getSecondScreenAppUrl = (
  url: string,
  screenId: string,
  clientName: string
) => {
  return `${url}?screenID=${screenId}&clientID=${clientName}`
}
